export default __webpack_public_path__ + "static/media/close.53191d6f.svg";